<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" color="#FFFF99">
                        <v-card-title>
                            <v-icon large left>mdi-files</v-icon>
                            Control de Documentos de Ingeniería
                            <v-spacer></v-spacer>
                            Remito N°: {{ codigo }}
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-card-text class="pt-2">
                            <v-row dense>
                                <v-col cols="12" md="4">
                                    Cliente: {{ datos.numcliente }} - {{ datos.cliente }}
                                </v-col>
                                <v-col cols="12" md="5">
                                    Obra: {{ datos.numobra }} - {{ datos.obra }}
                                </v-col>
                                <v-col cols="12" md="2">
                                    Proyectista: {{ datos.proyectista }}
                                </v-col>
                                <v-col cols="12" md="1">
                                    Fecha: {{ datos.fecha }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="3">Destinatario</v-col>
                                <v-col cols="12" sm="2" md="1">Copias</v-col>
                                <v-col cols="12" sm="1" md="1">e-Mail</v-col>
                                <v-col cols="12" sm="5" md="3">Nombre Recibió</v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="3">
                                    <v-checkbox dense label="Cliente" v-model="datos.checkcliente" hide-details
                                        class="font-class-name"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" md="1">{{ datos.copiacliente }}</v-col>
                                <v-col cols="12" sm="1" md="1"><v-checkbox dense v-model="datos.mailcliente"
                                        hide-details class="font-class-name"></v-checkbox></v-col>
                                <v-col cols="12" sm="5" md="3">{{ datos.recibiocliente }}</v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="3">
                                    <v-checkbox dense label="Jefe de Obra / Resp. Fabricación" v-model="datos.checkjefe"
                                        hide-details class="font-class-name"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" md="1">{{ datos.copiajefe }}</v-col>
                                <v-col cols="12" sm="1" md="1"><v-checkbox dense v-model="mailjefe" hide-details
                                        class="font-class-name"></v-checkbox></v-col>
                                <v-col cols="12" sm="5" md="3">{{ datos.recibiojefe }}</v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="3">
                                    <v-checkbox dense label="Subcontratista" v-model="datos.checksubcont" hide-details
                                        class="font-class-name"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="2" md="1">{{ datos.copiasubcont }}</v-col>
                                <v-col cols="12" sm="1" md="1"><v-checkbox dense v-model="datos.mailsubcont"
                                        hide-details class="font-class-name"></v-checkbox></v-col>
                                <v-col cols="12" sm="5" md="3">{{ datos.recibiosubcont }}</v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="4">
                                    <v-radio-group v-model="datos.estado" row dense hide-details
                                        class="mini-radio-group">
                                        <v-radio label="Envío" value="E"></v-radio>
                                        <v-radio label="Recepción" value="R"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox v-model="datos.controlada" label="Copia Cotrolada" dense hide-details
                                        class="mini-check"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headers" :items="listadofiltrado" :single-expand="true"
                                locale="es-ar" class="elevation-1 compact-table" :items-per-page="2000"
                                hide-default-footer :loading="loadtable" loading-text="Cargando... Espere por favor"
                                no-data-text="No hay datos disponibles">
                                <!-- <template v-slot:item.select="{ item }">
                                <v-checkbox v-model="item.select" dense hide-details class="mini-check"></v-checkbox>
                            </template>
<template v-slot:item.estado="{ item }">
                                <v-radio-group v-model="item.estado" row dense hide-details class="mini-radio-group">
                                    <v-radio label="Obs." value="B"></v-radio>
                                    <v-radio label="A.c/O" value="C"></v-radio>
                                    <v-radio label="Apr." value="D"></v-radio>
                                </v-radio-group>
                            </template> -->
                                <template v-slot:item.archivootro="{ item }">
                                    <div v-if="item.archivootro == '-'">
                                        {{ item.nomplano }}
                                    </div>
                                    <div v-if="item.archivootro != '-'">
                                        {{ item.archivootro }}
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card color="orange" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>

            </v-app>
        </div>
    </v-dialog>
</template>

<style scoped>
.font-class-name {
    font-size: 12px;
}

/* Texto general dentro de la tabla */
.v-data-table td {
    font-size: 12px;
    padding: 4px 8px !important;
}

/* Checkbox */
.mini-check .v-icon {
    font-size: 12px !important;
}

.mini-check .v-input--selection-controls__ripple {
    width: 0;
    height: 0;
}

/* Radios */
.mini-radio-group .v-icon {
    font-size: 12px !important;
}

.mini-radio-group .v-label {
    font-size: 11px;
}

/* Elimina espacios extra */
.mini-radio-group .v-input--selection-controls__input {
    margin-right: 4px;
}

.compact-table .v-input {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}
</style>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
export default {

    data() {
        return {
            lazy: false,
            valid: false,
            deshabilitar: false,
            loadtable: false,
            fecha: moment().format("DD/MM/YYYY"),
            codigo: "",
            remito: "",
            cliente: "",
            obra: "",
            proyectista: "",
            checkcliente: "",
            checkjefe: "",
            checksubcont: "",
            copiacliente: "",
            copiajefe: "",
            copiasubcont: "",
            mailcliente: "",
            mailjefe: "",
            mailsubcont: "",
            recibiocliente: "",
            recibiojefe: "",
            recibiosubcont: "",
            avance: "",
            descr: "",
            proyectistas: [],
            clientes: [],
            obras: [],
            listado: [],
            headers: [
                { text: "Recepción", value: "estado", sortable: false },
                { text: "Nombre", align: "start", sortable: false, value: "nomplano", },
                { text: "Revisión", value: "revision", sortable: false },
                { text: "Descripción", value: "descrplano", sortable: false },
                { text: "Archivo", value: "archivootro", sortable: false },
                { text: "Tipo", value: "tipoarchivo", sortable: false },
            ],


        };
    },
    watch: {
        cliente(newVal) {
            this.numcliente = this.cliente.numcliente;
            this.listadoobras();
        },
        obra(newVal) {

            this.cargarListados();

        },
    },
    props: ["visible", "datos", "listadofiltrado"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarcodigoremito();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
            this.$router.push({ name: "IngenieriaListadoremito" });
        },

        cargarcodigoremito() {
            let self = this;
            axios
                .get("/Ingenieria/Cargarcodigoremito?")
                .then((response) => {
                    self.remito = response.data;
                    self.codigo = "rD-" + response.data;
                })
                .catch((error) => {
                    self.remito = [];
                    console.log(error);
                });
        },
        listadoclientes() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoclientes?", {
                    params: {
                        filtrocliente: '',
                    },
                })
                .then((response) => {
                    self.clientes = response.data;
                })
                .catch((error) => {
                    self.clientes = [];
                    console.log(error);
                });
        },
        listadoobras() {
            //this.obras = [];
            console.log("ENTRO a obras")
            let self = this;
            axios
                .get("/Ingenieria/Listadoobras?", {
                    params: {
                        filtroobra: '',
                        filtrocliente: self.numcliente,
                    },
                })
                .then((response) => {
                    self.obras = response.data;
                })
                .catch((error) => {
                    self.obras = [];
                    console.log(error);
                });
        },
        listadoproyectistas() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoproyectistas?")
                .then((response) => {
                    self.proyectistas = response.data;
                })
                .catch((error) => {
                    self.proyectistas = [];
                    console.log(error);
                });
        },
        cargarListados() {
            this.loadtable = true;
            let self = this;
            axios
                .get("/Ingenieria/Listadoplanos?", {
                    params: {
                        numcliente: self.cliente.numcliente,
                        numobra: self.obra.numobra,
                        avance: "",
                        proyectista: "",
                        descrplano: "",
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },

        guardar() {
            this.$swal({
                title: "Guardar Remito",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var datos = {
                        remito: this.remito,
                        numcliente: this.datos.numcliente,
                        numobra: this.datos.numobra,
                        responsable: this.datos.proyectista,
                        fecha: this.datos.fecha,
                        ndocumentos: this.listadofiltrado.length,
                        estado: this.datos.estado,
                        visible: "ON",
                        checkcliente: this.datos.checkcliente,
                        copiacliente: this.datos.copiacliente,
                        mailcliente: this.datos.mailcliente,
                        recibiocliente: this.datos.recibiocliente,
                        checkjefe: this.datos.checkjefe,
                        copiajefe: this.datos.copiajefe,
                        mailjefe: this.datos.mailjefe,
                        recibiojefe: this.datos.recibiojefe,
                        checksubcont: this.datos.checksubcont,
                        copiasubcont: this.datos.copiasubcont,
                        mailsubcont: this.datos.mailsubcont,
                        recibiosubcont: this.datos.recibiosubcont,
                        controlada: this.datos.controlada,
                        detalle: this.listadofiltrado,
                    };

                    axios
                        // Cambiá esta URL por la real de tu backend
                        .post("/Ingenieria/GuardarRemito", datos)
                        .then(() => {
                            this.showAlert({
                                icon: "success",
                                title: "Remito guardado con éxito",
                                vm: this,
                            });

                            this.vaciarModels();
                            this.$emit("close"); // o this.$emit("guardado")
                        })
                        .catch((error) => {
                            console.log(error);

                            this.showAlert({
                                icon: "error",
                                title: "Error al guardar",
                                vm: this,
                            });
                        })
                        .finally(() => {
                            this.deshabilitar = false;
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 5000,
            });
        },


    },
};
</script>
